var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0537 14.4896L13.3424 16.7877L17.9291 12.1914",
    stroke: "url(#paint0_linear_2261_121406)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3046 5.42022C13.9599 4.85993 15.033 4.85993 15.6977 5.42022L17.1982 6.71173C17.4831 6.95864 18.0149 7.15807 18.3947 7.15807H20.0091C21.0157 7.15807 21.8419 7.98426 21.8419 8.99088V10.6053C21.8419 10.9756 22.0414 11.5169 22.2883 11.8018L23.5798 13.3022C24.1401 13.9575 24.1401 15.0306 23.5798 15.6953L22.2883 17.1958C22.0414 17.4806 21.8419 18.0124 21.8419 18.3923V20.0067C21.8419 21.0133 21.0157 21.8395 20.0091 21.8395H18.3947C18.0244 21.8395 17.4831 22.0389 17.1982 22.2858L15.6977 23.5774C15.0425 24.1377 13.9694 24.1377 13.3046 23.5774L11.8042 22.2858C11.5193 22.0389 10.9875 21.8395 10.6076 21.8395H8.96476C7.95814 21.8395 7.13195 21.0133 7.13195 20.0067V18.3828C7.13195 18.0124 6.93253 17.4806 6.69511 17.1958L5.4131 15.6858C4.8623 15.0306 4.8623 13.967 5.4131 13.3117L6.69511 11.8018C6.93253 11.5169 7.13195 10.9851 7.13195 10.6148V8.98138C7.13195 7.97476 7.95814 7.14857 8.96476 7.14857H10.6076C10.978 7.14857 11.5193 6.94914 11.8042 6.70224L13.3046 5.42022Z",
    stroke: "url(#paint1_linear_2261_121406)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2261_121406",
    x1: 14.4914,
    y1: 12.1914,
    x2: 14.4914,
    y2: 16.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2261_121406",
    x1: 14.5,
    y1: 5,
    x2: 14.5,
    y2: 23.9976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.883dd88c6e4c026e9bed9c6e4dfbc662.svg";
export { ForwardRef as ReactComponent };